<div class="input-check">
      <div class="input" (click)="_click()">
            <i class="fa-solid fa-check" *ngIf="value === true || value === 'true'"></i>
      </div>
      <div class="text">
            <span>{{label}}</span>
      </div>      
</div>
